import { ServiceFieldOption } from "./ServiceFieldOption"

export class ServiceField {
  id: number
  name: string
  type: number
  serviceFieldOptions: ServiceFieldOption[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, name?: string, type?: number, serviceFieldOptionsJson?: any) {
    this.id = id
    this.name = name ?? ''
    this.type = type ?? 1
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.serviceFieldOptions = serviceFieldOptionsJson ? serviceFieldOptionsJson.map((s: any) => new ServiceFieldOption(s.id, s.active, s.additionalCost, s.displayOrder, s.value)) : []
  }
}
